module.exports = __webpack_public_path__ + "img/BE0670848040.952ae95b.png";